/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ProcessingReconcileParamsSlaMinutes } from './processingReconcileParamsSlaMinutes';

/**
 * Parameters for PROCESSING submission reconciliation job.

Force-promotes submissions stuck in PROCESSING past the SLA and alerts admins.
 */
export interface ProcessingReconcileParams {
  slaMinutes?: ProcessingReconcileParamsSlaMinutes;
}
